import Swal from "sweetalert2/dist/sweetalert2";
import toastr from 'toastr';

// Composant : bouton toolbar -> pop-up de sélection d'un catalogue + d'un numéro de départ
// -> POST de réordonnancement alphabétique des collections (regroupements) du catalogue,
// puis rafraîchissement de la grille.
// Calqué sur catalogue.js (dropdown Swal native) et PopupIncludeChild.js (refresh grille Kendo).
export default class ReorderCollectionsAlpha {

    constructor($view) {
        this.$view = $view;
        this.urlCatalogues = this.$view.data('url-catalogues');
        this.urlReorder = this.$view.data('url-reorder');
        this.gridSelector = this.$view.data('grid-selector');
        // Libellés injectés par la vue : ils vivent dans LabelsBO.resx, pas dans le bundle JS.
        this.labelNumeroDepart = this.$view.data('label-numero-depart');
        this.messageConfirmation = this.$view.data('message-confirmation');
        this.Init();
    }

    Init() {
        let self = this;
        this.$view.on("click", '.bt-reorder-alpha', (e) => {
            e.preventDefault();
            self.openPopup();
        });
    }

    // Charge les catalogues puis affiche la pop-up de sélection + numéro de départ + validation
    openPopup() {
        let self = this;

        $.getJSON(self.urlCatalogues, (catalogues) => {
            // PascalCase attendu (sérialisation Newtonsoft côté BO) : { Id, Nom }
            //
            // On construit le <select> à la main plutôt que d'utiliser `input: 'select'` :
            // Swal n'accepte qu'UN seul input natif, or le ticket 82251 en demande deux
            // (catalogue + numéro de départ). D'où le passage par `html`, qui permet au passage
            // d'afficher enfin le message d'avertissement ReorderCataloguesAlphabeticallyConfirm,
            // présent en resx mais jusqu'ici jamais rendu.
            //
            // Les noms de catalogues sont échappés ($('<div>').text(...).html()) : ils viennent
            // de la base et sont réinjectés dans du HTML brut.
            const options = $.map(catalogues, (c) =>
                `<option value="${c.Id}">${$('<div>').text(c.Nom).html()}</option>`
            ).join('');

            Swal.fire({
                title: 'Trier un catalogue par ordre alphabétique',
                html: `
                    <p class="text-muted small mb-3">${self.messageConfirmation}</p>
                    <!-- mx-0 est indispensable : .swal2-select porte des marges laterales de
                         ~40px qui s'ajoutent au w-100 et font deborder le conteneur (barre de
                         defilement horizontale dans la pop-up). -->
                    <select id="swal-catalogue" class="swal2-select w-100 mx-0">
                        <option value="">Sélectionnez un catalogue</option>
                        ${options}
                    </select>
                    <label for="swal-numero-depart" class="d-block mt-3 mb-1">
                        ${self.labelNumeroDepart}
                    </label>
                    <input id="swal-numero-depart" type="number"
                           class="swal2-input mt-0" min="1" max="1000000" step="1" value="1">`,
                // Le focus doit rester sur le formulaire, pas sur le bouton de confirmation.
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: 'Trier',
                cancelButtonText: 'Annuler',
                showLoaderOnConfirm: true,
                // Avec `html`, inputValidator ne s'applique plus : la validation des deux champs
                // se fait donc ici, avant l'appel serveur.
                preConfirm: () => {
                    const catalogueId = Swal.getPopup().querySelector('#swal-catalogue').value;
                    const numeroDepartBrut = Swal.getPopup().querySelector('#swal-numero-depart').value;

                    if (!catalogueId) {
                        Swal.showValidationMessage('Vous devez sélectionner un catalogue');
                        return false;
                    }

                    // Champ vidé ⇒ on retombe sur le défaut du ticket (1) plutôt que d'envoyer
                    // une chaîne vide, que le binding MVC transformerait en null.
                    const numeroDepart = numeroDepartBrut === '' ? 1 : parseInt(numeroDepartBrut, 10);

                    if (isNaN(numeroDepart) || numeroDepart < 1) {
                        Swal.showValidationMessage('Le numéro de départ doit être un entier supérieur ou égal à 1');
                        return false;
                    }

                    return $.ajax({
                        type: "POST",
                        url: self.urlReorder,
                        data: { catalogueId: catalogueId, numeroDepart: numeroDepart }
                    }).catch(() => {
                        Swal.showValidationMessage('Une erreur est survenue.');
                    });
                },
                allowOutsideClick: () => !Swal.isLoading(),
            }).then((result) => {
                if (result.isConfirmed) {
                    toastr.success(result.value.resultMessage);
                    self.refreshGrid();
                }
            });
        });
    }

    // Rafraîchit la grille Kendo des regroupements pour refléter le nouvel ordre
    refreshGrid() {
        const kendoGrid = $(this.gridSelector).data("kendoGrid");
        if (kendoGrid) {
            kendoGrid.dataSource.read().done(() => kendoGrid.refresh());
        }
    }
}
